var _path, _ellipse, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmittedOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 88,
    viewBox: "0 0 432 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.198 48.8315C93.7461 62.2173 114.712 67.4228 155.145 65.5637C195.579 63.7045 219.029 73.0002 242.502 73.0002C265.975 73.0002 319.376 65.5637 272.453 53.6653C225.53 41.7669 393 43.0002 395 34.5002C397 26.0002 289 41.5002 223 24.0002C157 6.50017 69.2862 2.7252 40.8328 20.9447C12.3795 39.1641 152.649 35.4458 123.198 48.8315Z",
    fill: "#EBFEFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.517,
    cy: 13.5167,
    rx: 10.2649,
    ry: 10.2649,
    transform: "rotate(44.7867 330.517 13.5167)",
    fill: "#EBFEFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6.11939,
    transform: "matrix(0.709734 0.70447 -0.704469 0.709735 353.346 12.7244)",
    fill: "#EBFEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 50.9999C12.4999 49.1007 9.0796 50.4999 8.49992 47.9998C7.92024 45.4998 25.0005 44.2429 45.0001 41.0001C64.9997 37.7572 93.9994 43.9997 93.9999 46.9998C94.0004 50 86.9999 48.2958 73 50.9999C59.0001 53.704 52.3022 51.7073 41.5 50.9999Z",
    fill: "#EBFEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 46.9999C321.5 47 307.5 49.2378 307.5 52.9999C307.5 56.762 331.501 56.9463 349 60.5002C366.5 64.0542 389.66 59.5543 407.5 58.0002C425.341 56.4461 429.896 58.0315 430 55.5002C430.104 52.9689 418 51.5001 403.5 49.5001C389 47.5001 351.5 46.9999 336.5 46.9999Z",
    fill: "#EBFEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196 32C196 20.96 204.96 12 216 12C227.04 12 236 20.96 236 32C236 43.04 227.04 52 216 52C204.96 52 196 43.04 196 32ZM202 32L212 42L230 24L227.18 21.16L212 36.34L204.82 29.18L202 32Z",
    fill: "#1DB498"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedOrder);
export default __webpack_public_path__ + "static/media/submitted_order.214e2fb8582906202a5e4da0ce2a72c8.svg";
export { ForwardRef as ReactComponent };